import React from "react";

import { useTheme, useMediaQuery } from "@material-ui/core";
import PropTypes from "prop-types";

import RbButton from "components/RbButton";
import RbButtonGroup from "components/RbButtonGroup";
import RbCheckboxField from "components/RbCheckboxField";
import RbGrid from "components/RbGrid";
import RbNumberField from "components/RbNumberField";
import RbTextField from "components/RbTextField";
import ManufacturerAutocomplete from "containers/ManufacturerAutocomplete";
import ProductCategoryAutocomplete from "containers/ProductCategoryAutocomplete";
import ProductStatusSelect from "containers/ProductStatusSelect";
import FieldsProvider from "fields/components/FieldsProvider";

function ProductForm(props) {
  const { fields, onSubmit, onDelete, onChange, valid, newer } = props;

  const theme = useTheme();

  const downSm = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(fields.values);
  };

  return (
    <form noValidate onSubmit={handleSubmit}>
      <FieldsProvider fields={fields} onChange={onChange}>
        <RbGrid container columnGap={5} rowGap={5}>
          <RbGrid item xs={12} md={6}>
            <RbTextField fieldName="name" id="name" label="Name" required />
          </RbGrid>
          <RbGrid item xs={12} md={2}>
            <RbTextField fieldName="code" id="code" label="Code" required />
          </RbGrid>
          <RbGrid item xs={6} md={2}>
            <RbNumberField
              fieldName="price"
              id="price"
              label="Price"
              decimalScale={2}
            />
          </RbGrid>
          <RbGrid item xs={6} md={2}>
            <RbNumberField
              fieldName="inventory"
              id="inventory"
              label="Inventory"
              required
            />
          </RbGrid>
          <RbGrid item xs={6} md={2}>
            <ProductStatusSelect
              fieldName="status"
              id="status"
              label="Status"
              required
            />
          </RbGrid>
          <RbGrid item xs={12} md={4}>
            <ManufacturerAutocomplete
              fieldName="manufacturer"
              id="manufacturer"
              label="Manufacturer"
              required
            />
          </RbGrid>
          <RbGrid item xs={12} md={6}>
            <RbTextField
              fieldName="thumbnailUrl"
              id="thumbnailUrl"
              label="Thumbnail URL"
            />
          </RbGrid>
          <RbGrid item xs={12} md={6}>
            <ProductCategoryAutocomplete
              fieldName="categories"
              id="categories"
              label="Categories"
              multiple
            />
          </RbGrid>
          <RbGrid item xs={6} md={2} pt={{ xs: 0, md: 5 }}>
            <RbCheckboxField fieldName="public" id="public" label="Public" />
          </RbGrid>
          <RbGrid item xs={12} md={12}>
            <RbTextField
              multiline
              fieldName="description"
              id="description"
              label="Description"
              required
              rows={4}
            />
          </RbGrid>
          <RbGrid item xs={12} md={12}>
            <RbButtonGroup gap={8} fullWidth={downSm}>
              <RbButton
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                disabled={!valid}
              >
                Save
              </RbButton>
              <RbButton
                variant="contained"
                size="large"
                onClick={onDelete}
                disabled={newer}
              >
                Delete
              </RbButton>
            </RbButtonGroup>
          </RbGrid>
        </RbGrid>
      </FieldsProvider>
    </form>
  );
}

ProductForm.propTypes = {
  fields: PropTypes.shape({
    values: PropTypes.object,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  newer: PropTypes.bool.isRequired,
};

export default React.memo(ProductForm);
